const AVAILABILITY_PATTERNS = [
  'available spots',
  'available spot',
  'fully booked',
  'no longer available',
  'obsaden',
  'obsadený',
  'kapacit',
  'capacity',
  '0 available',
  'no available',
]

const COUPON_PATTERNS = [
  'coupon is invalid',
  'coupon cannot be used',
  'kupón je neplatný',
  'kupón nie je možné',
  'kupón nelze použít',
  'kupón je neplatný',
  'partner key is not configured',
  'partner key missing',
]

function allErrorMessages(data: { errors?: Record<string, string[]> | string | string[] }): string[] {
  const errors = data?.errors
  if (!errors) return []
  if (typeof errors === 'string') return [errors]
  if (Array.isArray(errors)) return errors.filter((m): m is string => typeof m === 'string')
  if (typeof errors === 'object') {
    return Object.values(errors).flat().filter((m): m is string => typeof m === 'string')
  }
  return []
}

function isAvailabilityError(messages: string[]): boolean {
  const lower = messages.join(' ').toLowerCase()
  return AVAILABILITY_PATTERNS.some((p) => lower.includes(p.toLowerCase()))
}

function isCouponError(messages: string[]): boolean {
  const lower = messages.join(' ').toLowerCase()
  return COUPON_PATTERNS.some((p) => lower.includes(p.toLowerCase()))
}

/**
 * From API client: fetch throws Error with message "API {status}: {responseText}".
 * Returns i18n key for user-friendly message: 'availability' → term fully booked,
 * 'coupon' → coupon verification failed, else generic + contact branch.
 */
export function getReservationErrorKey(error: unknown): 'plugin.error.fullyBooked' | 'plugin.error.couponFailed' | 'plugin.error.submitGenericWithContact' {
  const message = error instanceof Error ? error.message : String(error)
  const match = /^API \d{3}: (.+)$/s.exec(message)
  if (!match) return 'plugin.error.submitGenericWithContact'
  try {
    const data = JSON.parse(match[1]) as { errors?: Record<string, string[]> | string | string[] }
    const messages = allErrorMessages(data)
    if (messages.length > 0) {
      if (isAvailabilityError(messages)) return 'plugin.error.fullyBooked'
      if (isCouponError(messages)) return 'plugin.error.couponFailed'
    }
  } catch {
    // not JSON or invalid
  }
  return 'plugin.error.submitGenericWithContact'
}
